import React, {memo, ReactNode, useCallback} from 'react';
import {CONTROL_TYPE_ID_ALARM, CONTROL_TYPE_ID_MKK, ControlModel, ControlTypeModel, ThreePhaseSet} from '../../types/control';
import {useRPC} from '../../hooks/rpc';
import {ThreePhaseControlComponent} from './component';
import {useDispatch, useSelector} from 'react-redux';
import {useDebounce} from '../../hooks/debounce';
import {entityUpdatedAction} from '../../store/control/actions';
import {useLocalization} from "../../hooks/localization";
import {useApproving} from '../../hooks/approving';
import { useMessage } from '../../hooks/message';
import { passwordCheckingTimeoutAction } from '../../store/ui/actions';

export enum PhaseStatus {
    Stop,
    Up,
    Down
}

type Props = {
    control: ControlModel;
    controlType: ControlTypeModel<ThreePhaseSet>;
    children?: ReactNode;
};

export const ThreePhaseControl = memo(function CurtainControl(props: Props) {
    const {control, children, ...restProps} = props;
    const approving = useApproving()
    const {t} = useLocalization();
    const {failure} = useMessage();
    const passwordTimeoutSycle = useSelector(state => state.ui.passwordTimeoutSycle)
    const [rpc] = useRPC();
    const updateControl = useDebounce((id: string, status: number) => {
        rpc.updateControlValue(id, status).catch(failure)
    }, 200)

    const dispatch = useDispatch();

    const openAreYouSure = useCallback(status => {
        approving(() => {
            dispatch(passwordCheckingTimeoutAction(true))
            dispatch(entityUpdatedAction({...control, isUpdating: true}, 'control'));
            updateControl(control.id, status)
        });
    }, [control, approving, dispatch, updateControl]);

    const click = useCallback((status: PhaseStatus) => {
        if (control.type_id !== CONTROL_TYPE_ID_ALARM && control?.parameters?.['password_control'] && !passwordTimeoutSycle) {
            openAreYouSure(status);
        } else {
            dispatch(entityUpdatedAction({...control, isUpdating: true}, 'control'));
            updateControl(control.id, status);
        }
    }, [control, openAreYouSure, updateControl, dispatch, passwordTimeoutSycle]);

    return (
        <ThreePhaseControlComponent control={control} click={click} {...restProps}>
            {children}
        </ThreePhaseControlComponent>
    );
});
